import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showBanner } from '../../global-state/banner-slice'
import { OpportunityInterestDetail, OpportunityInterestListItem } from '../../lib/types'
import { opportunityInterestServices } from '../../services'
import { AllocationRequestDetailPresenter } from './allocation-request-detail-presenter'

type LocationState = {
  listItem?: OpportunityInterestListItem
}

export function AllocationRequestDetailContainer() {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const listItem = (location.state as LocationState | null)?.listItem

  const [interest, setInterest] = useState<OpportunityInterestDetail | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  const load = useCallback(async () => {
    if (!id) return
    setIsLoading(true)
    const data = await opportunityInterestServices.getById(id)
    if (data.status === 200 && data.interest) {
      setInterest(data.interest)
    } else {
      setInterest(null)
      dispatch(
        showBanner({
          text:
            data.code === 'opportunity-interest-not-found'
              ? 'Allocation request not found'
              : data.message || 'Failed to load allocation request',
          variant: 'error-banner',
        }),
      )
    }
    setIsLoading(false)
  }, [dispatch, id])

  useEffect(() => {
    void load()
  }, [load])

  const enrichment = listItem && interest && listItem.id === interest.id ? listItem : undefined

  return (
    <AllocationRequestDetailPresenter
      interest={interest}
      enrichment={enrichment}
      isLoading={isLoading}
      onBack={() => navigate('/allocation-requests')}
    />
  )
}
